import React from 'react'

export const MicrosoftEdgeInstructions = () => (
  <div className="mbxl">
    <p>It looks like you're using Microsoft Edge.</p>

    <p>
      Microsoft Edge doesn't support bookmarklets like our "Add to Babylist"
      button. We recommend you use another browser like Google Chrome or Firefox
      and then come back to this page. You can also add items with our apps.
    </p>

    <p>
      If you're more technical, here is a little hack (it's safe) that lets you
      use our bookmark button from Microsoft Edge:
    </p>

    <ol>
      <li>Click the ... menu button in the top right</li>
      <li>Click on "Open with Internet Explorer"</li>
      <li>
        That should open our site in an IE window instead of Edge. And you CAN
        add and use the button there.
      </li>
    </ol>
  </div>
)

export default MicrosoftEdgeInstructions
